/** Límites al gestionar una alerta de botón EU (alineados con la columna en base de datos). */
export const BUTTON_ALERT_COMMENT_MIN_LEN = 8;
export const BUTTON_ALERT_COMMENT_MAX_LEN = 500;
